import  { useState, useEffect } from 'react';

export function GitRepos() {
  const [data, setData] = useState(null);

  useEffect(() => {
    async function fetchRepos() {
      try {
        const response = await fetch('https://api.github.com/users/Eliya-G/repos');
        const repos = await response.json();
        setData(repos);
      } catch (err) {
        console.error(err.message);
        setData(null);
      }
    }
    fetchRepos();
  }, []); 

  return data;
}
